/*
 * Copyright (c) 2022-2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'

const entity = {
  name: {
    displayName: 'name'
  },
  lang: {},
  printName: {
    displayName: 'printName',
    formConfig: {
      required: false
    }
  }
}
export default IKDataEntity.ModelFactory(entity, {})
